export const toPT_BRCapitalize = (value) => {
  return !value
    ? value
    : value
        .split(" ")
        .map(
          (w) =>
            ["da", "das", "de", "des", "di", "do", "dos"].includes(w)
              ? w
              : w.replace(/(^.)|(\s\w\.)|(\s([^e]))/g, (l) => l.toUpperCase())
          // : w.replace(/(^|\s)\S/g, (l) => l.toUpperCase())
        )
        .join(" ");
};

export const uuid = () => {
  const url = URL.createObjectURL(new Blob());
  const [id] = url.toString().split("/").reverse();
  URL.revokeObjectURL(url);
  return id;
};
